import { defineStore } from "pinia"
import type { Video } from "~/models/video"
import type { ApiResponse } from "~/types/api"

// video :: upload video
export interface UploadVideoResponse extends ApiResponse {
	data: Video
}
const UploadVideo = {
	method: "POST" as any,
	url: () => "videos/upload"
}

// video :: get video
export interface GetVideoRequest {
	video: any
}
export interface GetVideoResponse extends ApiResponse {
	data: Video
}
const GetVideo = {
	method: "POST" as any,
	url: (id: number) => `videos/${id}`
}

export const useVideoApiUrl = () => ({
	UploadVideo,
	GetVideo
})

export const useVideoStore = defineStore("video", () => {
	const state = {}

	const uploadVideo = async (video: File) => {
		const formData = new FormData()
		formData.set("video", video)
		const data = await $fetch<UploadVideoResponse>(UploadVideo.url(), {
			...useFetchConfig(),
			method: UploadVideo.method,
			body: formData
		})
		return data.data
	}

	const getVideo = async (id: number) => {
		const data = await $fetch<GetVideoResponse>(GetVideo.url(id), {
			...useFetchConfig(),
			method: GetVideo.method
		})
		return data.data
	}

	return {
		...state,
		uploadVideo,
		getVideo
	}
})
